// Global Imports
import React, { useEffect } from "react";

// Local Imports
// import RacingPromotions from "./pages/racing_promotions";
// import SportsPromotions from "./pages/sports_promotions";
import Calculators from "./pages/Calculators";
import Promotions from "./pages/promotions";
// import ValueGolfTips from "./pages/value_golf_tips";
import CheatSheet from "./pages/bookie-cheat-sheet/bookie-cheat-sheet";
import CalendarApp from "./pages/calendar/App";
// import OddsComparison from "./pages/odds-comparison";

// types, enums and interface
import Banner2 from "./assets/banner-2.png";
import Banner3 from "./assets/banner-3.png";
import BetFairRacing from "./assets/betfair-racing.gif";
type TabsAU =
  | "Promotions"
  | "Odds Comparison"
  | "Tips"
  | "Bookmaker Reviews"
  | "Calendar"
  // | "Racing Promotions"
  // | "Sports Promotions"
  // | "Live Odds"
  | "Calculators";

// type TabsUK =
//   | "Promotions"
//   | "Odds Comparison"
//   | "Tips"
//   | "Bookie Cheat Sheet"
//   | "Calendar"
//   // | "Racing Promotions"
//   // | "Sports Promotions"
//   // | "Casino Promotions"
//   // | "Live Odds"
//   | "Calculators";

type Country = "AU" | "UK";

// Constants
const tabsAU: string[] = [
  "Promotions",
  // "Odds Comparison",
  "Bookmaker Reviews",
  // "Calendar",
  // "Racing Promotions",
  // "Sports Promotions",
  // "Live Odds",
  "Calculators",
  // "Tips",
];

// const tabsUK: string[] = [
//   "Promotions",
//   "Odds Comparison",
//   "Bookie Cheat Sheet",
//   "Calendar",
//   // "Racing Promotions",
//   // "Sports Promotions",
//   // "Casino Promotions",
//   // "Live Odds",
//   "Calculators",
//   "Tips",
// ];
interface IProps {
  isDesktopResolution: boolean;
}
// Render Main Componnet
const CKServiceApp: React.FC<IProps> = ({ isDesktopResolution }) => {
  const [selectedTab, setSelectedTab] = React.useState<TabsAU>("Promotions");
  const [urlHash, setUrlHash] = React.useState<string>(window.location.hash);
  const [
    selectedCountry,
    // setSelectedCountry
  ] = React.useState<Country>("AU");

  // render pages
  const renderPage = (tab: TabsAU) => {
    switch (tab) {
      case "Promotions":
        return (
          <div className="py-4">
            <Promotions
              selectedCountry={selectedCountry}
              isDesktopResolution={isDesktopResolution}
            />
          </div>
        );
      // case "Odds Comparison":
      //   return (
      //     <div className="py-4">
      //       <OddsComparison
      //         selectedCountry={selectedCountry}
      //         isDesktopResolution={isDesktopResolution}
      //       />
      //     </div>
      //   );

      // case "Tips":
      //   return (
      //     <div className="py-4">
      //       <ValueGolfTips />
      //     </div>
      //   );

      case "Bookmaker Reviews":
        return (
          <div className="py-5">
            <CheatSheet />
          </div>
        );

      case "Calendar":
        return (
          <div className="py-4">
            <CalendarApp
              selectedCountry={selectedCountry}
              isDesktopResolution={isDesktopResolution}
            />
          </div>
        );

      /*case "Racing Promotions":
        return (
          <div className="py-4">
            <RacingPromotions selectedCountry={selectedCountry} />
          </div>
        );*/

      /*case "Sports Promotions":
        return (
          <div className="py-4">
            <SportsPromotions selectedCountry={selectedCountry} />
          </div>
        );*/

      /*case "Casino Promotions":
        return (
          <div className="py-4">
            <p>Casino Promotions</p>
          </div>
        );*/

      /*case "Live Odds":
        return (
          <div className="py-4">
            <p>Live Odds</p>
          </div>
        );*/

      case "Calculators":
        return (
          <div className="py-4">
            <Calculators />
          </div>
        );

      default:
        <p>Racing Promotions</p>;
        break;
    }
  };

  // const handleSelectCountry = (target: any) => {
  //   setSelectedCountry(target);
  // };

  const setURLHash = (tab: TabsAU) => {
    console.log("tab", tab);
    let hash = "";
    switch (tab) {
      case "Promotions":
        hash = "#promotions-racing";
        break;
      case "Bookmaker Reviews":
        hash = "#bookmaker-reviews";
        break;
      case "Calculators":
        hash = "#calculators";
        break;
      default:
        hash = "";
        break;
    }
    setUrlHash(hash);
    window.location.hash = hash;
  };

  useEffect(() => {
    switch (urlHash) {
      case "#promotions-racing":
        setSelectedTab("Promotions");
        break;
      case "#bookmaker-reviews":
        setSelectedTab("Bookmaker Reviews");
        break;
      case "#calculators":
        setSelectedTab("Calculators");
        break;
      default:
        setSelectedTab("Promotions");
        break;
    }
  });

  return (
    <React.Fragment>
      <div className="md:flex md:justify-center">
        <div className="px-3 header-ck w-full">
          <div className="flex justify-end">
            {" "}
            {/*<div className="flex flex-col text-center">*/}
            {/*  <label>Market</label>*/}
            {/*  <div className="flex items-center justify-center">*/}
            {/*    /!*<div*!/*/}
            {/*    /!*  onClick={() => handleSelectCountry("AU")}*!/*/}
            {/*    /!*  className={`bg-white cursor-pointer rounded-md  focus:outline-none border border-gray-200 transition-colors duration-75 ease-in-out border-r-0 px-3 py-1 ${*!/*/}
            {/*    /!*    selectedCountry === "AU"*!/*/}
            {/*    /!*      ? "bg-gray-300"*!/*/}
            {/*    /!*      : "hover:bg-gray-300"*!/*/}
            {/*    /!*  }`}*!/*/}
            {/*    /!*>*!/*/}
            {/*    /!*  AU 🇦🇺*!/*/}
            {/*    /!*</div>*!/*/}
            {/*    /!*<div*!/*/}
            {/*    /!*  onClick={() => handleSelectCountry("UK")}*!/*/}
            {/*    /!*  className={`bg-white cursor-pointer rounded-tr-md focus:outline-none rounded-br-md border border-gray-200 transition-colors duration-75 ease-in-out px-3 py-1 ${*!/*/}
            {/*    /!*    selectedCountry === "UK"*!/*/}
            {/*    /!*      ? "bg-gray-300"*!/*/}
            {/*    /!*      : "hover:bg-gray-300"*!/*/}
            {/*    /!*  }`}*!/*/}
            {/*    /!*>*!/*/}
            {/*    /!*  UK 🇬🇧*!/*/}
            {/*    /!*</div>*!/*/}
            {/*  </div>*/}
            {/*</div>*/}
          </div>
          <div className="pt-3 bg-transparent promotion-tab">
            <nav className="flex w-full overflow-x-auto flex-nowrap sm:flex-row ">
              {selectedCountry === "AU" ? (
                <React.Fragment>
                  {tabsAU.map((tab: any, index: React.Key) => (
                    <div
                      key={index}
                      onClick={() => {
                        setSelectedTab(tab);
                        setURLHash(tab);
                      }}
                      className={`cursor-pointer text-center text-gray-600 py-4 px-6 block hover:text-blue-500 focus:outline-none w-full ${
                        selectedTab === tab && "active"
                      } `}
                    >
                      {tab}
                    </div>
                  ))}{" "}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {/*{tabsUK.map((tab: any, index: React.Key) => (*/}
                  {/*  <div*/}
                  {/*    key={index}*/}
                  {/*    onClick={() => setSelectedTab(tab)}*/}
                  {/*    className={`cursor-pointer text-center text-gray-600 py-4 px-6 block hover:text-blue-500 focus:outline-none w-full ${*/}
                  {/*      selectedTab === tab && "active"*/}
                  {/*    } `}*/}
                  {/*  >*/}
                  {/*    {tab}*/}
                  {/*  </div>*/}
                  {/*))}{" "}*/}
                </React.Fragment>
              )}
            </nav>
          </div>
          <div className="w-full h-full mt-1">{renderPage(selectedTab)}</div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CKServiceApp;
